import type { ReactNode } from 'react';

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;
const TRAILING_SENTENCE_PUNCTUATION_PATTERN = /[.,;:!?)]+$/;

interface SplitUrlSegment {
  linkedUrl: string;
  trailingPunctuation: string;
}

function splitTrailingPunctuationFromUrl(segment: string): SplitUrlSegment {
  const trailingPunctuationMatch = segment.match(TRAILING_SENTENCE_PUNCTUATION_PATTERN);
  if (trailingPunctuationMatch === null) {
    return { linkedUrl: segment, trailingPunctuation: '' };
  }
  const trailingPunctuation = trailingPunctuationMatch[0];
  return {
    linkedUrl: segment.slice(0, segment.length - trailingPunctuation.length),
    trailingPunctuation,
  };
}

export function linkifyText(text: string): ReactNode[] {
  const segments = text.split(URL_PATTERN);
  return segments
    .filter(function keepNonEmptySegment(segment) {
      return segment.length > 0;
    })
    .flatMap(function renderSegment(segment, segmentIndex) {
      const isUrlSegment = segment.startsWith('http://') || segment.startsWith('https://');
      if (isUrlSegment === true) {
        const { linkedUrl, trailingPunctuation } = splitTrailingPunctuationFromUrl(segment);
        const linkNode = (
          <a
            key={'announcement-link-' + segmentIndex}
            href={linkedUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-zooprimary underline break-all"
          >
            {linkedUrl}
          </a>
        );
        if (trailingPunctuation.length === 0) {
          return [linkNode];
        }
        return [
          linkNode,
          <span key={'announcement-link-trailing-' + segmentIndex}>{trailingPunctuation}</span>,
        ];
      }
      return [<span key={'announcement-text-' + segmentIndex}>{segment}</span>];
    });
}
